// extracted by mini-css-extract-plugin
module.exports = {"main-map__marker":"style_main-map__marker__T_joV","main-map__triangle":"style_main-map__triangle__t8qWA"};